export default __webpack_public_path__ + "static/media/digifarm_logo_approved.a92f2bf5.png";